import React from 'react';
import { Box, HStack, VStack, Button, Separator, Heading, Spacer, Text } from '@chakra-ui/react';
import * as forms from '../forms';
import theme from '../theme';
import moment from 'moment';

const Forms = {
	supervisor_handoff: forms.ProjectInfoForm,
	loadout_list: forms.LoadoutListForm,
	hazardous_energy_loto: forms.HazardousEnergyLOTOForm,
	delta_p_list: forms.DeltaPForm,
	delta_p_field_list: forms.DeltaPFieldForm,
	daily_field_record: forms.DailyFieldRecordForm,
	pre_dive_meeting: forms.PreDiveMeetingForm,
	pre_dive_equipment_safety_list: forms.PreDiveEquipmentForm,
	general_daily_toolbox: forms.GeneralDailyToolboxForm,
	dive_log: forms.DiveLogForm
};

const formTitle = formDefinition => {
	switch (formDefinition.id) {
		case 'hazardous_energy_loto':
			return 'Diving Lockout/Tagout Hazardous Energy Verification Checklist';
		case 'delta_p_list':
			return 'Differential Pressure Hazards Checklist';
		case 'delta_p_field_list':
			return 'Differential Pressure Field Hazards Checklist';
		default:
			return formDefinition.title;
	}
};

export default ({
	activeLog,
	saveChanges,
	attachmentsIndex,
	currentPacket,
	formData,
	formDefinition,
	dataAPI,
	projectInfoCrew,
	supervisorPacketFormsList,
	hasDailyPackets,
	handoffData,
	saveForm,
	currentForm,
	setActiveLog,
	setAttachmentsIndex,
	submitting,
	currentPacketSubmitted,
	editMode,
	setEditMode,
	isUnassigned
}) => {
	const [diver, setDiver] = React.useState('');

	const Renderer = React.useMemo(() => Forms[currentForm?.form_id], [currentForm?.form_id]);

	React.useMemo(() => setEditMode(false), [currentForm?.form_id]);

	const handleExport = () => {
		const url =
			'/generatepdf' +
			('?packet=' + currentPacket.packet_nid) +
			(currentForm.form_id ? '&form=' + currentForm.form_id : '') +
			(diver ? '&diver=' + encodeURI(diver) : '');

		window.open(window.location.origin + url, '_blank');
	};

	return (
		<Box px={4} pt={4} pb={attachmentsIndex ? 100 : 0}>
			<HStack spacing={2} justify="flex-end" p={2}>
				<VStack spacing="8px" mb="24px" align="flex-start">
					<Heading size="lg" pt="24px" color={theme.colors.blue[700]}>
						{formTitle(formDefinition)}
					</Heading>
					<Text fontSize={18}>{currentPacket.title}</Text>
					{currentPacket.packet_tag === 'supervisor' &&
						supervisorPacketFormsList.includes(currentForm.form_id) && (
							<Text>Last Updated: {moment.unix(currentPacket.changed).format('MM/DD/YYYY')}</Text>
						)}
				</VStack>
				<Spacer />
				{currentPacketSubmitted && window.canEditSubmittedPackets && (
					<Button
						color={editMode ? theme.colors.black : theme.colors.white}
						bg={editMode ? 'gray.100' : theme.colors.blue[700]}
						_hover={{ backgroundColor: editMode ? 'gray.200' : theme.colors.blue[800] }}
						variant={editMode ? 'ghost' : 'solid'}
						onClick={() => setEditMode(editMode => !editMode)}
					>
						Edit Form
					</Button>
				)}
				<Button
					color={theme.colors.white}
					bg={theme.colors.blue[700]}
					_hover={{ backgroundColor: theme.colors.blue[800] }}
					onClick={handleExport}
				>
					Export Form
				</Button>
				{currentPacket.packet_tag !== 'supervisor' &&
				formDefinition.id !== 'delta_p_list' &&
				formDefinition.id !== 'hazardous_energy_loto' ? (
					<Button
						color={theme.colors.white}
						bg={theme.colors.blue[700]}
						_hover={{ backgroundColor: theme.colors.blue[800] }}
						onClick={() => setAttachmentsIndex(0)}
					>
						Form Attachments
					</Button>
				) : null}
			</HStack>
			<Separator />
			<Renderer
				dataAPI={dataAPI}
				saveChanges={saveChanges}
				handoffData={handoffData}
				edit={editMode && !submitting}
				currentForm={currentForm}
				hasDailyPackets={hasDailyPackets}
				formData={formData}
				formDefinition={formDefinition}
				currentPacket={currentPacket}
				isSubmitted={currentPacketSubmitted}
				projectInfoCrew={projectInfoCrew}
				activeLog={activeLog}
				saveForm={saveForm}
				setDiver={setDiver}
				setActiveLog={setActiveLog}
				isUnassigned={isUnassigned}
			/>
		</Box>
	);
};
